module.exports = __webpack_public_path__ + "media/images/icons/logo-7d0338a980cdd611196d53a5ec622c8d.svg";